import { ref } from 'vue';
import { useRouter } from 'vue-router';

// Module-level singleton stack. Each entry is a fullPath visited.
// The last entry is the current route; second-to-last is the previous one.
const stack = ref([]);
let suppressNext = false;

export function setupNavigationTracking(router) {
    router.afterEach((to) => {
        if (suppressNext) {
            suppressNext = false;
            return;
        }
        stack.value.push(to.fullPath);
    });
}

export function useNavigationStack() {
    const router = useRouter();

    const goBack = () => {
        if (stack.value.length < 2) return;
        stack.value.pop();
        const target = stack.value[stack.value.length - 1];
        suppressNext = true;
        router.push(target);
    };

    return { stack, goBack };
}
